<template>
  <div style="position: relative">
    <div id="activeShow"></div>
    <div style="position: absolute; left: -10000px" class="show" id="allShow">
      <div v-for="(pageItem, index) in pdfPage" :key="index + 'pdfPageitem'">
        <!-- 公司主体信息 -->
        <div
          class="template_con"
          v-if="pageItem.type == 'mainInfo' && pageItem.typeIndex == 0"
        >
          <div class="main back_1">
            <div
              class="brand"
              :class="`brand${index + 1}`"
              v-for="(item, index) in (pageItem?.data?.brand || '').split('')"
              :key="index"
            >
              {{ item }}
            </div>
            <div class="company_info_con">
              <div class="company_name">{{ pageItem.data?.companyName }}</div>
            </div>
          </div>
        </div>
        <div
          class="template_con"
          v-if="pageItem.type == 'mainInfo' && pageItem.typeIndex == 1"
        >
          <div class="main back_2"></div>
        </div>
        <div
          class="template_con"
          v-if="pageItem.type == 'mainInfo' && pageItem.typeIndex == 2"
        >
          <div class="main back_3">
            <div class="title-en">
              Company profile
              <img
                src="@/assets/img/pdfTemplate/template_12/titlebg.png"
                alt=""
                class="title-bg"
              />
            </div>
            <div class="title">公司介绍</div>
            <div class="product_con">
              <div class="product-desc">
                {{ pageItem?.data?.vision }}
              </div>
              <div class="product-img">
                <img src="@/assets/img/pdfTemplate/template_12/product3.png" />
                <img src="@/assets/img/pdfTemplate/template_12/product4.png" />
              </div>
              <div class="product-desc">
                {{ pageItem?.data?.mission }}
              </div>
            </div>
          </div>
        </div>
        <!-- 产品与服务内容 -->
        <div class="template_con" v-if="pageItem.type == 'productList'">
          <div class="main back_4">
            <div class="title-en">
              Product Service
              <img
                src="@/assets/img/pdfTemplate/template_12/titlebg.png"
                alt=""
                class="title-bg"
              />
            </div>
            <div class="title">产品服务</div>
            <div class="product_con">
              <div
                class="product-item"
                v-for="(item, index) in pageItem.multipleData"
                :key="index"
              >
                <img
                  src="@/assets/img/pdfTemplate/template_12/productbg3.png"
                  class="left-bg"
                />
                <img
                  src="@/assets/img/pdfTemplate/template_12/productbg4.png"
                  class="mid-bg"
                />
                <div class="right-bg">
                  <img :src="item?.fileList[0]?.fileUrl" />
                  <div class="cover-bg"></div>
                </div>
                <div class="product-info">
                  <div class="product-title">{{ item?.projectName }}</div>
                  <div class="desc">{{ item?.projectIntro }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 项目与案例 0 -->
        <div
          class="template_con"
          v-if="pageItem.type == 'projectList' && pageItem.typeIndex == 0"
        >
          <div class="main back_5"></div>
        </div>
        <!-- 项目与案例 1 -->
        <div
          class="template_con"
          v-if="pageItem.type == 'projectList' && pageItem.typeIndex == 1"
        >
          <div class="main back_6">
            <div class="title-en">
              Project Introduction
              <img
                src="@/assets/img/pdfTemplate/template_12/titlebg.png"
                alt=""
                class="title-bg"
              />
            </div>
            <div class="title">项目介绍</div>
            <div class="project-con">
              <div class="left">
                <img
                  :src="item"
                  v-for="(item, index) in extractImgSrc(
                    pageItem?.data?.workContent
                  ).slice(0, 4)"
                  :key="index"
                />
              </div>
              <div class="right">
                <div class="project-name">
                  {{ pageItem?.data?.projectName }}
                </div>
                <div class="projectdesc">
                  {{ pageItem?.data?.projectIntro }}
                </div>
                <img
                  :src="pageItem.data?.xcxQrCode"
                  v-if="pageItem.data?.xcxQrCode"
                  class="qrcode"
                />
                <div>扫码查看</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 项目与案例 2 -->
        <div
          class="template_con"
          v-if="pageItem.type == 'projectList' && pageItem.typeIndex == 2"
        >
          <div class="main back_7">
            <div class="title-en">
              Project Introduction
              <img
                src="@/assets/img/pdfTemplate/template_12/titlebg.png"
                alt=""
                class="title-bg"
              />

              <img
                :src="pageItem.data?.xcxQrCode"
                v-if="pageItem.data?.xcxQrCode"
                class="qrcode"
              />
            </div>
            <div class="title">项目介绍</div>
            <div class="project-con">
              <img
                :src="item"
                v-for="(item, index) in extractImgSrc(
                  pageItem?.data?.workContent
                ).slice(0, 6)"
                :key="index"
              />
            </div>
          </div>
        </div>

        <!-- 荣誉与认证 0 -->
        <div
          class="template_con"
          v-if="pageItem.type == 'honorList' && pageItem.typeIndex == 0"
        >
          <div class="main back_8"></div>
        </div>

        <!-- 荣誉与认证 1 -->
        <div
          class="template_con"
          v-if="pageItem.type == 'honorList' && pageItem.typeIndex == 1"
        >
          <div class="main back_9">
            <img
              src="@/assets/img/pdfTemplate/template_12/honorbg2.png"
              class="honor-title"
            />
            <div class="honor-con">
              <div
                class="honor-item"
                v-for="(item, num) in pageItem.multipleData"
                :key="num"
              >
                <img :src="item.fileList[0].fileUrl" />
                <div class="honor-name">{{ item.content }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 荣誉与认证 2 -->
        <div
          class="template_con"
          v-if="pageItem.type == 'honorList' && pageItem.typeIndex == 2"
        >
          <div class="main back_10">
            <img
              src="@/assets/img/pdfTemplate/template_12/honorbg2.png"
              class="honor-title"
            />
            <div class="honor-con">
              <div
                class="honor-item"
                v-for="(item, num) in pageItem.multipleData"
                :key="num"
              >
                <img :src="item.fileList[0].fileUrl" />
                <div class="honor-name">{{ item.content }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 合作伙伴 -->
        <div
          class="template_con"
          v-if="pageItem.type == 'partnerList' && pageItem.typeIndex == 0"
        >
          <div class="main back_11"></div>
        </div>
        <div
          class="template_con"
          v-if="pageItem.type == 'partnerList' && pageItem.typeIndex == 1"
        >
          <div class="main back_12">
            <div class="title-en">
              partner company
              <img
                src="@/assets/img/pdfTemplate/template_12/titlebg.png"
                alt=""
                class="title-bg"
              />
            </div>
            <div class="title">合作企业</div>
            <div class="partner-con">
              <div
                class="partner-item"
                v-for="(item, index) in pageItem.multipleData"
                :key="index + 'partner'"
              >
                <div class="parter-bg">
                  <img class="img" :src="item.fileList[0].fileUrl" />
                </div>
                <div class="desc">{{ item.name }}</div>
                <div class="desc">{{ item.content }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 团队成员  -->
        <div
          class="template_con"
          v-if="pageItem.type == 'memberList' && pageItem.typeIndex == 0"
        >
          <div class="main back_13"></div>
        </div>

        <div
          class="template_con"
          v-if="pageItem.type == 'memberList' && pageItem.typeIndex == 1"
        >
          <div class="main back_14">
            <div class="title-en">
              team members
              <img
                src="@/assets/img/pdfTemplate/template_12/titlebg.png"
                alt=""
                class="title-bg"
              />
            </div>
            <div class="title">团队成员</div>
            <div class="member-con">
              <div
                class="member-item"
                v-for="(item, index) in pageItem.multipleData"
                :key="index"
              >
                <img :src="item.editAvatar || item.avatar" class="member-img" />
                <div class="member_info">
                  <span class="name">{{ item.name }}</span>
                  <span class="job">{{ item.job }}</span>
                </div>
                <div class="project-name">
                  {{ item.projectIntro }}
                </div>
                <div class="project-desc">
                  {{ item.experience }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 联系方式  -->
        <div class="template_con" v-if="pageItem?.type == 'contact'">
          <div class="main back_15">
            <div class="left">
              <div class="contact-title">感谢观看</div>
              <div class="contact-title-en">Thank you for watching</div>
              <div class="contact-item">
                <img
                  src="@/assets/img/pdfTemplate/template_12/email.png"
                  alt=""
                />&nbsp;&nbsp;{{ pageItem?.data?.email }}
              </div>
              <div class="contact-item">
                <img
                  src="@/assets/img/pdfTemplate/template_12/phone.png"
                  alt=""
                />&nbsp;&nbsp;{{ pageItem?.data?.mobile }}
              </div>
              <div class="contact-item">
                <img
                  src="@/assets/img/pdfTemplate/template_12/address.png"
                  alt=""
                />&nbsp;&nbsp;{{ pageItem?.data?.city }}
              </div>
            </div>
            <img class="right" :src="pageItem?.data?.wxUrl" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import dayjs from "dayjs";
export default {
  name: "Template_9",
  props: ["activeBoardIndex", "pdfPage", "activePDFPage"],
  components: {},
  computed: {
    ...mapState(["userInfo", "activeCompanyInfo"]),
  },
  data() {
    return {};
  },
  methods: {
    dayjs,
    extractImgSrc(html = "") {
      // 正则表达式匹配img标签中的src属性
      // 考虑了src可能有引号或无引号的情况，以及各种引号类型
      const regex = /<img[^>]+src=["']?([^"'>]+)["']?/gi;
      const srcArray = [];
      let match;

      // 循环查找所有匹配项
      while ((match = regex.exec(html)) !== null) {
        // 提取并保存src值
        srcArray.push(match[1]);
      }

      return srcArray;
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.show {
  position: absolute;
  left: 30px;
  top: 30px;
  width: 800px;
  height: 800px;
  overflow: auto;
}

.template_con,
.template_con2 {
  word-break: break-all;
  width: 800px;
  height: 450px;
  overflow: hidden; // 防止内容溢出影响高度计算
  .main {
    width: 100%;
    height: 100%;
    padding: 20px;
    position: relative;
    font-family: Source Han Serif CN, Source Han Serif CN;
    box-sizing: border-box; // 避免padding导致实际高度超过容器
  }
  .title-en {
    font-family: Heiti SC, Heiti SC;
    font-weight: 400;
    font-size: 28px;
    color: #3e3e3e;
    line-height: 29px;
    display: flex;
    align-items: center;
    position: relative;
    .title-bg {
      width: 25px;
      margin-left: 8px;
    }
    .qrcode {
      position: absolute;
      top: -15px;
      right: 0;
      width: 80px;
      height: 80px;
    }
  }
  .title {
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 700;
    font-size: 21px;
    color: #ffe71d;
    line-height: 30px;
    position: relative;
    top: -13px;
    margin-bottom: 19px;
    &:after {
      position: absolute;
      content: "";
      left: 0;
      bottom: -13px;
      height: 1px;
      width: 30px;
      background: #ffe71d;
    }
  }
  .back_1 {
    height: 100%;
    background-image: url("@/assets/img/pdfTemplate/template_12/mainbg.png");
    background-size: cover; // 改用cover确保完全覆盖容器（可能裁剪边缘但不变形）
    // 或使用100% 100% + 调整定位
    // background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center; // 确保背景图居中显示
    position: relative;
    .brand {
      font-family: "pdf12font", sans-serif;
      color: #ffe71d;
      position: absolute;
    }
    .brand1 {
      font-family: "pdf12font", sans-serif;
      color: #ffe71d;
      font-size: 187px;
      line-height: 261px;
      top: 14px;
      left: 245px;
    }
    .brand2 {
      font-family: "pdf12font", sans-serif;
      color: #ffe71d;
      font-size: 208px;
      line-height: 292px;
      top: 71px;
      left: 352px;
    }
    .brand3 {
      font-family: "pdf12font", sans-serif;
      color: #ffe71d;
      font-size: 100px;
      line-height: 140px;
      top: 182px;
      left: 283px;
    }
    .brand4 {
      font-family: "pdf12font", sans-serif;
      color: #ffe71d;
      font-size: 100px;
      line-height: 140px;
      top: 243px;
      left: 325px;
    }
    .company_info_con {
      position: absolute;
      left: 0;
      top: 353px;
      width: 100%;
      padding: 0 10px;
      display: flex;
      justify-content: center;

      .company_name {
        background: #000000;
        border-radius: 70px;
        padding: 7px 30px;
        font-weight: 500;
        font-size: 20px;
        color: #ffffff;
        line-height: 30px;
      }
    }
  }
  .back_2 {
    height: 100%;
    background-image: url("@/assets/img/pdfTemplate/template_12/productbg1.png");
    background-size: cover; // 改用cover确保完全覆盖容器（可能裁剪边缘但不变形）
    // 或使用100% 100% + 调整定位
    // background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center; // 确保背景图居中显示
  }
  .back_3 {
    height: 100%;
    background-image: url("@/assets/img/pdfTemplate/template_12/productbg2.png");
    background-size: cover; // 改用cover确保完全覆盖容器（可能裁剪边缘但不变形）
    // 或使用100% 100% + 调整定位
    // background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center; // 确保背景图居中显示
    padding: 53px 48px;
    .product_con {
      font-size: 12px;
      color: #ffffff;
      line-height: 17px;
      width: 357px;
      .product-desc {
        text-indent: 2em;
      }
      .product-img {
        margin: 17px 0;
        display: flex;
        justify-content: space-between;
        img {
          width: 169px;
          height: 78px;
        }
      }
    }
  }
  .back_4 {
    height: 100%;
    background-image: url("@/assets/img/pdfTemplate/template_12/productbg5.png");
    background-size: cover; // 改用cover确保完全覆盖容器（可能裁剪边缘但不变形）
    // 或使用100% 100% + 调整定位
    // background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center; // 确保背景图居中显示
    padding: 49px 48px;
    .product_con {
      display: flex;
      flex-wrap: wrap;
      .product-item {
        margin-right: 25px;
        margin-bottom: 14px;
        width: 339px;
        height: 125px;
        display: flex;
        position: relative;
        .left-bg {
          width: 4px;
          height: 100%;
          background-image: url("@/assets/img/pdfTemplate/template_12/productbg3.png");
          background-size: cover; // 改用cover确保完全覆盖容器（可能裁剪边缘但不变形）
          // 或使用100% 100% + 调整定位
          // background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center; // 确保背景图居中显示
        }
        .mid-bg {
          flex: 1;
          min-width: 0;
          height: 100%;
          background-image: url("@/assets/img/pdfTemplate/template_12/productbg4.png");
          background-size: cover; // 改用cover确保完全覆盖容器（可能裁剪边缘但不变形）
          // 或使用100% 100% + 调整定位
          // background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center; // 确保背景图居中显示
        }
        .right-bg {
          width: 122px;
          height: 100%;
          position: relative;
          > img {
            width: 100%;
            height: 100%;
          }
          .cover-bg {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: linear-gradient(
              to right,
              rgba(0, 0, 0, 0.8),
              rgba(0, 0, 0, 0)
            );
          }
        }
        .product-info {
          position: absolute;
          top: 14px;
          left: 17px;
          width: 217px;
          .product-title {
            font-weight: 700;
            font-size: 13px;
            color: #ffffff;
            line-height: 19px;
            margin-bottom: 5px;
          }
          .desc {
            font-weight: 500;
            font-size: 9px;
            color: #ffffff;
            line-height: 13px;
          }
        }
        &:nth-child(2n) {
          margin-right: 0;
        }
      }
    }
  }
  .back_5 {
    height: 100%;
    background-image: url("@/assets/img/pdfTemplate/template_12/projectbg1.png");
    background-size: cover; // 改用cover确保完全覆盖容器（可能裁剪边缘但不变形）
    // 或使用100% 100% + 调整定位
    // background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center; // 确保背景图居中显示
  }
  .back_6 {
    height: 100%;
    background-image: url("@/assets/img/pdfTemplate/template_12/projectbg2.png");
    background-size: cover; // 改用cover确保完全覆盖容器（可能裁剪边缘但不变形）
    // 或使用100% 100% + 调整定位
    // background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center; // 确保背景图居中显示
    background-color: #000000;
    padding: 49px 48px;
    .project-con {
      display: flex;
      .left {
        flex: 1;
        min-width: 0;
        margin-right: 24px;
        display: flex;
        flex-wrap: wrap;
        img {
          height: 134px;
          width: 221px;
          margin-right: 10px;
          margin-bottom: 10px;
          &:nth-child(2n) {
            margin-right: 0;
          }
        }
      }
      .right {
        width: 228px;
        .project-name {
          font-weight: 500;
          font-size: 17px;
          color: #ffffff;
          line-height: 17px;
        }
        .projectdesc {
          font-weight: 500;
          font-size: 10px;
          color: #ffffff;
          line-height: 18px;
          margin: 15px 0 8px;
        }
        .qrcode {
          width: 80px;
          height: 80px;
        }
      }
    }
  }
  .back_7 {
    height: 100%;
    background-image: url("@/assets/img/pdfTemplate/template_12/projectbg2.png");
    background-size: cover; // 改用cover确保完全覆盖容器（可能裁剪边缘但不变形）
    // 或使用100% 100% + 调整定位
    // background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center; // 确保背景图居中显示
    background-color: #000000;
    padding: 49px 48px;
    .project-con {
      display: flex;
      flex-wrap: wrap;
      img {
        height: 139px;
        width: 228px;
        margin-right: 10px;
        margin-bottom: 10px;
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
  .back_8 {
    height: 100%;
    background-image: url("@/assets/img/pdfTemplate/template_12/honorbg1.png");
    background-size: cover; // 改用cover确保完全覆盖容器（可能裁剪边缘但不变形）
    // 或使用100% 100% + 调整定位
    // background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center; // 确保背景图居中显示
  }
  .back_9 {
    height: 100%;
    background-image: url("@/assets/img/pdfTemplate/template_12/projectbg2.png");
    background-size: cover; // 改用cover确保完全覆盖容器（可能裁剪边缘但不变形）
    // 或使用100% 100% + 调整定位
    // background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center; // 确保背景图居中显示
    background-color: #000000;
    padding: 49px 48px;
    .honor-title {
      display: block;
      margin: 0 auto 55px;
      width: 213px;
    }
    .honor-con {
      display: flex;
      flex-wrap: wrap;
      padding: 0 3px;
      .honor-item {
        margin-right: 34px;
        &:last-child {
          margin-right: 0;
        }

        img {
          display: block;
          width: 210px;
          height: 144px;
          margin-bottom: 10px;
        }
        .honor-name {
          font-weight: 500;
          font-size: 18px;
          color: #ffffff;
          line-height: 27px;
          text-align: center;
        }
      }
    }
  }
  .back_10 {
    height: 100%;
    background-image: url("@/assets/img/pdfTemplate/template_12/projectbg2.png");
    background-size: cover; // 改用cover确保完全覆盖容器（可能裁剪边缘但不变形）
    // 或使用100% 100% + 调整定位
    // background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center; // 确保背景图居中显示
    background-color: #000000;
    padding: 49px 48px;
    .honor-title {
      display: block;
      margin: 0 auto 55px;
      width: 213px;
    }
    .honor-con {
      display: flex;
      flex-wrap: wrap;
      padding: 0 53px;
      .honor-item {
        margin-right: 51px;
        &:last-child {
          margin-right: 0;
        }

        img {
          display: block;
          width: 165px;
          height: 215px;
          margin-bottom: 10px;
        }
        .honor-name {
          font-weight: 500;
          font-size: 18px;
          color: #ffffff;
          line-height: 27px;
          text-align: center;
        }
      }
    }
  }
  .back_11 {
    height: 100%;
    background-image: url("@/assets/img/pdfTemplate/template_12/partnerbg1.png");
    background-size: cover; // 改用cover确保完全覆盖容器（可能裁剪边缘但不变形）
    // 或使用100% 100% + 调整定位
    // background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center; // 确保背景图居中显示
  }
  .back_12 {
    height: 100%;
    background-image: url("@/assets/img/pdfTemplate/template_12/projectbg2.png");
    background-size: cover; // 改用cover确保完全覆盖容器（可能裁剪边缘但不变形）
    // 或使用100% 100% + 调整定位
    // background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center; // 确保背景图居中显示
    background-color: #000000;
    padding: 49px 48px;
    .partner-con {
      display: flex;
      flex-wrap: wrap;
      padding: 0 34px;
      .partner-item {
        width: 133px;
        margin-right: 33px;
        margin-bottom: 25px;
        .parter-bg {
          height: 79px;
          position: relative;
          background: #ffffff;
          img {
            position: absolute;
            height: 58px;
            width: auto;
            display: block;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .desc {
          margin-top: 9px;
          font-weight: 500;
          font-size: 10px;
          color: #ffffff;
          line-height: 10px;
          text-align: center;
        }
        &:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }
  .back_13 {
    height: 100%;
    background-image: url("@/assets/img/pdfTemplate/template_12/memberbg1.png");
    background-size: cover; // 改用cover确保完全覆盖容器（可能裁剪边缘但不变形）
    // 或使用100% 100% + 调整定位
    // background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center; // 确保背景图居中显示
  }
  .back_14 {
    height: 100%;
    background-image: url("@/assets/img/pdfTemplate/template_12/projectbg2.png");
    background-size: cover; // 改用cover确保完全覆盖容器（可能裁剪边缘但不变形）
    // 或使用100% 100% + 调整定位
    // background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center; // 确保背景图居中显示
    background-color: #000000;
    padding: 49px 48px;
    .member-con {
      display: flex;
      flex-wrap: wrap;
      .member-item {
        width: 170px;
        margin-right: 8px;
        &:last-child {
          margin: 0;
        }
        .member-img {
          width: 100%;
          height: 170px;
        }
        .member_info {
          margin: 21px 0 13px;
          display: flex;
          .name {
            font-weight: 500;
            font-size: 15px;
            color: #ffffff;
            line-height: 14px;
          }
          .job {
            padding: 4px 7px;
            background: #ffffff;
            border-radius: 30px;
            font-size: 10px;
            color: #9c6142;
            line-height: 9px;
            margin-left: 38px;
          }
        }
        .project-name {
          font-size: 10px;
          color: #ffffff;
          line-height: 14px;
          margin-bottom: 5px;
        }
        .project-desc {
          font-size: 8px;
          color: #ffffff;
          line-height: 14px;
        }
      }
    }
  }
  .back_15 {
    height: 100%;
    background-image: url("@/assets/img/pdfTemplate/template_12/projectbg2.png");
    background-size: cover; // 改用cover确保完全覆盖容器（可能裁剪边缘但不变形）
    // 或使用100% 100% + 调整定位
    // background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center; // 确保背景图居中显示
    background-color: #000000;
    padding: 0px 114px 0 157px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      flex: 1;
      min-width: 0;
      .contact-title {
        font-weight: 600;
        font-size: 25px;
        color: #ffffff;
        line-height: 35px;
        margin-bottom: 2px;
      }
      .contact-title-en {
        font-weight: 600;
        font-size: 9px;
        color: #ffffff;
        line-height: 13px;
        margin-bottom: 19px;
      }
      .contact-item {
        display: flex;
        align-items: center;
        margin-bottom: 6px;
        img {
          width: 25px;
          height: 25px;
          margin-right: 5px;
        }
        font-weight: 700;
        font-size: 10px;
        color: #ffffff;
        line-height: 13px;
      }
    }
    .right {
      width: 152px;
      height: auto;
    }
  }
}
</style>
